import { ReactElement, useState } from "react"
import { Loading, Pagination } from "@wfp/ui"
import BaseTable, { AutoResizer } from "react-base-table"
import { useGetFetchingDetailsQuery } from "services/household/fetchingOperations"
import { formatDate } from "utils/helpers"

type Props = {
  surveyId: number
}

const SurveyFetchDetails = ({ surveyId }: Props): ReactElement => {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const { data: details, isFetching: isLoading } = useGetFetchingDetailsQuery(
    { surveyId, skip: page === 1 ? 0 : (page - 1) * pageSize, take: pageSize },
    { skip: !surveyId },
  )

  const columns = [
    {
      key: "message",
      dataKey: "message",
      title: "Message",
      width: 600,
      flexGrow: 1,
      className: "!py-2 !leading-4",
      cellRenderer: ({ rowData }) => <div className="w-11/12">{rowData.message || ""}</div>,
    },
    {
      key: "fetchingResponseCode",
      dataKey: "fetchingResponseCode",
      title: "Response code",
      width: 150,
    },
    {
      key: "recordsNumberFetched",
      dataKey: "recordsNumberFetched",
      title: "Records fetched",
      width: 150,
    },
    {
      key: "runAt",
      dataKey: "runAt",
      title: "Date",
      width: 150,
      cellRenderer: ({ rowData }) => formatDate(rowData.runAt, "DD/MM/YYYY HH:mm"),
    },
  ]

  if (isLoading) return <Loading active withOverlay={false} small className="mt-2" />

  return (
    <div className="mt-2">
      <p>
        <b>Fetching details</b>
      </p>
      <div style={{ height: "35vh", minHeight: "35vh", marginTop: "10px" }}>
        <AutoResizer>
          {({ width, height }) => (
            <BaseTable
              data={details?.items ?? []}
              width={width}
              height={height}
              rowKey="fetchingDetailId"
              className="custom-table !overflow-x-hidden"
              estimatedRowHeight={50}
              headerHeight={45}
              columns={columns}
              emptyRenderer={() => <p>No records to display</p>}
            />
          )}
        </AutoResizer>
      </div>

      <Pagination
        totalItems={details?.count ?? 0}
        pageSize={pageSize}
        pageSizes={[10, 20, 30]}
        page={page}
        onChange={event => {
          const item = event as unknown as { page: number; pageSize: number }
          setPage(item.page)
          setPageSize(item.pageSize)
        }}
      />
    </div>
  )
}

export default SurveyFetchDetails
